const getBaseUrl = () => process.env.REACT_APP_API_BASE_URL;
const getFlaskUrl = () => process.env.REACT_APP_FLASK_API_URL;
// const getBaseUrl  "https://9mwlfol6v0.execute-api.eu-west-2.amazonaws.com/v1";
// console.log(getBaseUrl, "--baseUrl");
export const getUrl = (type) => {
  // const baseUrl = "https://9mwlfol6v0.execute-api.eu-west-2.amazonaws.com/v1";
  const baseUrl = getBaseUrl();
  const falskUrl = getFlaskUrl();
  switch (type) {
    case "user-login":
      return `${baseUrl}/regdata_login/`;
    case "user-signup":
      return `${baseUrl}/regdata_registeration`;
    case "fetch-file":
      return `${baseUrl}/regdata_get_files`;
    //   case 'fetch-ref-file':
    //     return `${baseUrl}/getreffiles`;
    case "file-download":
      return `${baseUrl}/regdata_download`;
    //   case 'file-upload':
    //     return `${baseUrl}/upload/`;
    //   case 'analytics-accuracy':
    //     return `${baseUrl}/getanalytics`;
    case "fetch-user":
      return `${baseUrl}/regdata_getusers`;
    case "get-firm-spec":
      return `${baseUrl}/regdata_getfirmspecifications`;
    //   case 'get-products':
    //     return `${baseUrl}/getproducts`;
    case "forgot-password":
      return `${baseUrl}/regdata_forgot_password/`;
    case "get-refdata":
      return `${baseUrl}/regdata_getrefdata`;
    case "get-super-admin-firm":
      return `${baseUrl}/regdata_get_super_admin_firm`;
    case "get-dashboard": // charts
      return `${baseUrl}/regdata_dashboard`;
    case "get-file-storage":
      return `${baseUrl}/regdata_get_filestorage`;
    case "delete-file":
      return `${baseUrl}/regdata_delete_files`;
    //   case 'get-accuracy-analytics':
    //     return `${baseUrl}/get_accuracy_analytics`;
    //   case 'get-middleware-mifid-file-data':
    //     return `${baseUrl}/get_middleware_mifid_file_data`;
    case "get-grid-data":
      return `${baseUrl}/regdata_get_grid_data`;
    case "get-flask-data":
      return `${falskUrl}/data`;
    case "get-falsk-filter-values":
      return `${falskUrl}/filter-values`;
    case "get-download-csv":
      return `${falskUrl}/download-csv`;
    case "get-presigned-url":
      return `${baseUrl}/get_regdata_presigned_url`;
    default:
      return baseUrl;
  }
};
